// extracted by mini-css-extract-plugin
module.exports = {"audioContainer":"styles_audioContainer__Cemw9","audioAvatar":"styles_audioAvatar__2Oua4","audioPlayIcon":"styles_audioPlayIcon__1Yoey","audioWaves":"styles_audioWaves__3bAfC"};